import { ApiInterface } from '../../utilities/ApiInterface';
import { Api } from '@automapa/svelte-automapa-template';
import { z } from 'zod';
import { type QueriesType, QueriesTypeSchema } from '../telematics/types';

export const RouteRecalculationRequestSchema = z.object({
    connection_ids: z.array(z.number()),
});
export type RouteRecalculationRequestType = z.infer<typeof RouteRecalculationRequestSchema>;

export class RouteApi extends ApiInterface {
    public static async triggerRouteRecalculation(api: Api, query: QueriesType): Promise<any[]> {
        return api.getData<QueriesType, any[]>(
            'post',
            '/route/trigger_route_recalculation',
            query,
            QueriesTypeSchema,
            z.array(z.any())
        );
    }
}
